import type { AmostraCardData } from './types';

export const formatarMoeda = (valor: number): string => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(valor);
};

export const getAreaDisplay = (amostra: AmostraCardData) => {
  const areaValue = amostra.tipoImovel === 'Terreno' ? amostra.areaTerreno : amostra.areaPrivativa;
  const label = amostra.tipoImovel === 'Terreno' ? 'Terreno' : 'Área Construída';
  return { areaValue, label };
};

export const PLACEHOLDER_IMAGE = 'https://via.placeholder.com/96x96?text=Sem+Imagem';
